import React from 'react';
import TravaillerAuMusee from '../components/TravaillerAuMusee';
import DonationWidget from '../components/DonationWidget';
import VisiteWidget from '../components/Visite';

function App() {
  return (
    <div className="App">
      <TravaillerAuMusee />
      <DonationWidget />
      <VisiteWidget />
    </div>
  );
}

export default App;
